import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = [
  "Placed",
  "Order Confirmed",
  "Shipped",
  "Out For Delivery",
  "Delivered",
];

export default function OrderTraker({ activeStep }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          "& .MuiStepLabel-root .Mui-completed": {
            color: "#B28585", // circle color (COMPLETED)
          },
          "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
            color: "B28585", // Just text label (COMPLETED)
          },
          "& .MuiStepLabel-root .Mui-active": {
            color: "#B28585", // circle color (ACTIVE)
          },
          "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
            color: "#B28585", // Just text label (ACTIVE)
          },
          "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
            fill: "#fff", // circle's number (ACTIVE)
          },
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              sx={{ color: "#9155FD", fontSize: "44px" }}
              className={``}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
